import api from 'service/api'

const dponetAPI = api.create('dponet')

const get = async ({ documentTemplateId = '' }) => {
  return await dponetAPI.get(
    `/document_templates/${documentTemplateId}/variables`,
  )
}

export default {
  get,
}
